export default "<h3>September 23, 2018</h3>\r\n<p>Update 0.31 fixes bugs.</p>";